module.exports = __webpack_public_path__ + "img/h_spades.9d11871a.png";